// extracted by mini-css-extract-plugin
export default {"modalOverlay":"dialog_modalOverlay__jFNBC","modalContent":"dialog_modalContent__Zfy9g","modalBody":"dialog_modalBody__+7abG","testBadge":"dialog_testBadge__ed4g3"};